module.exports = __webpack_public_path__ + "img/advant-5.b9487004.png";